import React, { useMemo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { includes } from 'lodash';

import { UnidataTable } from '~/components';

import { ADM, GFE, GFO, GFU, GPP, GPPE, GPPEM } from '~/constants/perfil';

import {
  dataInRequest,
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/atendimentoPosto/actions';


// import {
//   deleteBico,
//   findBico,
//   recordFiltering,
// } from '~/store/modules/bico/actions';

import MyForm from './form';

function AtendimentoPosto() {
  const data = useSelector((state) => state.atendimentoPosto);

  const { profile } = useSelector(state => state.user);

  const [isADM, setIsADM] = useState(false)
  const [isVisualizar, setIsVisualizar] = useState(false)

  const optionSN = useMemo(() => [
    { label: 'NAO', value: 'Não' },
    { label: 'SIM', value: 'Sim' },
  ]);

  const optionStatus = useMemo(() => [
    { label: 'Liberado', value: 'Liberado' },
    { label: 'Bloqueado', value: 'Bloqueado' },
    { label: 'Cancelado', value: 'Cancelado' },
  ]);

  const { glousuariotipo } = useSelector(
    (state) => state.user.profile
  );

  useEffect(() => {

    if (profile.perfcodigo == String(ADM)) {
      setIsADM(true)
    } else if (includes([GFE, GFO, GFU, GPP, GPPE, GPPEM], glousuariotipo)) {
      setIsVisualizar(true)
    }
  }, [profile, GFE, GFO, GFU, GPP, glousuariotipo])

  /*
            atpo_data_lancamento
           ,atpo_data_solicitacao
           ,atpo_data_atendimento
           ,atpo_numero_os
           ,atpo_local_atendimento
           ,poco_codigo
           ,prpo_codigo
           ,atpo_problema
           ,sopo_codigo
           ,atpo_solucao
           ,atpo_tecnico
           ,eqpo_codigo
           ,atpo_equipamento
           ,atpo_causa
           ,capo_codigo
           ,atpo_numero_serie_entrada_abastek
           ,atpo_numero_serie_saida_abastek



  */

  const header = useMemo(
    () => {

      let tempArrayHeader = [
        {
          id: 'atpo_data_solicitacao',
          label: 'Data solicitação',
          formatted: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
          align: 'left',
        },
        {
          id: 'atpo_data_atendimento',
          label: 'Data atendimento',
          formatted: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
          align: 'left',
        },
        {
          id: 'atpo_numero_os',
          label: 'Número da OS',
          filter: { type: 'text' },
        },
        {
          id: 'atpo_local_atendimento',
          label: 'Local atendimento',
          filter: { type: 'text' },
        },
        {
          id: 'atpo_problema',
          label: 'Problema',
          filter: { type: 'text' },
        },
        {
          id: 'atpo_solucao',
          label: 'Solução',
          align: 'left',
          filter: { type: 'text' },
        },
        {
          id: 'atpo_equipamento',
          label: 'Equipamento',
          align: 'left',
          with: '200px',
          filter: { type: 'text' },
        },
        {
          id: 'atpo_causa',
          label: 'Causa',
          align: 'left',
          filter: { type: 'text' },
        },
      ]

      isADM && tempArrayHeader.push({
        id: 'atpo_tecnico',
        label: 'Técnico',
        align: 'left',
        filter: { type: 'text' },
      })


      isADM && tempArrayHeader.push({
        id: 'atpo_numero_serie_entrada_abastek',
        label: 'Nº Serie de entrada da Abastek',
        align: 'left',
        filter: { type: 'text' },
      })

      isADM && tempArrayHeader.push({
        id: 'atpo_numero_serie_saida_abastek',
        label: 'Nº Serie de saída da Abastek',
        align: 'left',
        filter: { type: 'text' },
      })



      //   isADM && tempArrayHeader.push({
      //     id: 'atpo_numero_serie_entrada_abastek',
      //     label: 'Nº Serie de entrada Na Abastek',
      //     align: 'left',
      //     filter: { type: 'text' },
      //   })


      return tempArrayHeader
    },
    [isADM]
  );

  return (
    <UnidataTable
      pdf
      excel
      reportOrder="atpo_data_solicitacao asc"
      fixed
      read={recordFiltering}
      remove={deleteData}
      form={MyForm}
      find={findData}
      redux={data}
      header={header}
      detach="atpo_codigo"
      keys={['atpo_codigo']}
      view="vw_tb_atendimento_posto"
      reportTitle="Cadastro de Atendimentos Postos"
    />
  );
}

export default AtendimentoPosto;

